<template>
    <div>
        <div
            class="image-container"
            :key="refreshPhotoCount"
            :style="height ? { height: `${height}px` } : ''"
        >
            <section class="inner-container">
                <img
                    v-if="!loadingImage"
                    :src="imagePath"
                    :style="
                        imagePath === 'assets/icons/paw-solid-gray.svg'
                            ? { padding: '20%' }
                            : ''
                    "
                    class="user-image"
                />
                <loader v-else class="pl-2 pr-2" />
            </section>
            <div
                class="image-upload-icon"
                v-if="
                    isPatientProfile &&
                    _hasAccess('patient.profile.upload') &&
                    !loadingImage
                "
                @mouseover="onHoverProfileImage = true"
                @mouseleave="onHoverProfileImage = false"
            >
                <b-dropdown
                    variant="link"
                    no-caret
                    toggle-class="text-decoration-none"
                >
                    <!-- Use the camera icon as the button trigger without the default dropdown arrow -->
                    <template #button-content>
                        <i
                            v-show="!onHoverProfileImage"
                            class="cus-camera-upload"
                        ></i>
                        <i
                            v-show="onHoverProfileImage"
                            class="cus-camera-upload-black"
                        ></i>
                    </template>

                    <!-- Dropdown items -->
                    <b-dropdown-item href="#" @click="updatePhoto('upload')"
                        >Upload Photo</b-dropdown-item
                    >
                    <b-dropdown-item
                        v-if="
                            !patient.photo.includes('assets/img/no_avatar') &&
                            allowRotate
                        "
                        href="#"
                        @click="rotatePhoto(patient)"
                        >Rotate Photo</b-dropdown-item
                    >
                    <b-dropdown-item
                        v-if="!patient.photo.includes('assets/img/no_avatar')"
                        href="#"
                        @click="updatePhoto('remove')"
                        >Remove Photo</b-dropdown-item
                    >
                </b-dropdown>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import Patient from "@/services/patient";
import { DateTime } from "luxon";
import Loader from "@/components/elements/loader-list";

export default {
    components: {
        Loader
    },
    props: {
        patient: {
            type: Object,
            default: function () {
                return { photo: null };
            }
        },
        allowRotate: {
            type: Boolean,
            default: true
        },
        refreshPhotoCount: {
            type: Number
        },
        height: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            onHoverProfileImage: false,
            loadingImage: false
        };
    },
    computed: {
        isPatientProfile() {
            return this.$route.name === "patient_profile";
        },
        imagePath() {
            let path = "assets/icons/paw-solid-gray.svg";
            if (
                this.patient &&
                this.patient.photo &&
                !this.patient.photo.includes("assets/img/no_avatar")
            ) {
                path =
                    this._s3URL("patient", this.patient.id) +
                    "photos/thumb_" +
                    this.patient.photo +
                    "?ts=" +
                    DateTime.local().toMillis();
            }
            return path;
        }
    },
    methods: {
        updatePhoto(action) {
            this.$emit("update-photo", action);
        },
        rotatePhoto(patient) {
            let self = this;
            self.loadingImage = true;
            let params = new FormData();
            params.append("id", patient.id);

            Patient.rotatePhoto(params).then(response => {
                if (response.state == 0) {
                    self.$store
                        .dispatch("patient/getPatientDetails", {
                            id: patient.encoded_id,
                            encoded: true
                        })
                        .then(details => {
                            this.$root.$emit("update-patient-details", details);
                        })
                        .finally(() => {
                            self.loadingImage = false;
                            self._message(response.message, "success");
                        });
                    self.getImagePath(patient);
                } else {
                    self._message(response.message, "danger");
                }
            });
        }
    }
};
</script>
<style type="text/css" scoped>
.image-container {
    position: relative;
    border: 1px solid #cccccc;
    padding: 4px;
}
.inner-container {
    height: 100%;
    align-items: center;
    text-align: center;
    display: flex;
    justify-content: center;
}

.user-image {
    height: 100%;
    width: 100%;
    display: block; /* Ensure the image takes the full container width */
    object-fit: contain;
}

.image-upload-icon {
    position: absolute;
    bottom: 0;
    right: 0;
}

.cus-camera-upload,
.cus-camera-upload-black {
    height: 26px !important;
    width: 26px !important;
    margin: 0px !important;
}
</style>
